<app-popup class="job-more-options">
  <button
    class="job-more-options__btn btn-clean"
    type="button"
    aria-label="Plus d'options"
    i18n-aria-label
    appPopupTrigger
  >
    <app-svg-icon icon="dots" width="1em"></app-svg-icon>
  </button>
  <div class="job-more-options__menu" appPopupItem>
    <a
      class="btn-clean job-more-options__link"
      [routerLink]="['.']"
      [queryParams]="{ report: '' }"
      queryParamsHandling="merge"
      fragment="keep-scrolled"
      aria-label="Signaler l'offre"
      i18n-aria-label
      i18n
      (click)="report.emit()"
      >Signaler l'offre</a
    >
  </div>
</app-popup>
